import Admin from './admin.webp';
import Clip1 from './clip1.webp';
import Clip2 from './clip2.webp';
import Clip3 from './clip3.webp';

export default {
    Admin,
    Clip1,
    Clip2,
    Clip3
}